/* eslint-disable no-nested-ternary */
import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { IntlProvider } from "react-intl";
import "react-big-calendar-unavailable/lib/less/styles.less";
import "react-toggle-switch/dist/css/switch.min.css";
import "rmc-drawer/assets/index.css";
import "styles/bootstrap.scss";
import "styles/app.scss";
import "styles/app-rtl.scss";

import MainApp from "app/index";
import SuperAdmin from "app/SuperAdmin";
// import SignIn from "./SignIn";
// import SignUp from "./SignUp";
import moment from "moment";
import AppLocale from "../lngProvider";
import { setInitUrl } from "../actions/Auth";
import asyncComponent from "../util/asyncComponent";
import LoginPage from "./Login";
import SignupPage from "./Signup";
import ForgotPasswordPage from "./ForgotPassword";
import ResetPasswordPage from "./ResetPassword";
import CustomerFlow from "./CustomerFlow";
import ErrorHandler from "../containers/ErrorHandler";
import SuperAdminMobileScreen from "../containers/SuperAdminMobileScreenHandler";
import Customer from "../app/Customer";
import AccessDenied from "../components/AccessDenied";
import ContactUs from "../components/ContactUs/ContactUs";

const RestrictedRoute = ({ component: Component, authUser, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      authUser && Object.keys(authUser).length !== 0 ? (
        <Component {...props} user={authUser} />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
          }}
        />
      )
    }
  />
);

export function updateMomentLocale() {
  moment.updateLocale("vi", {
    months: [
      "tháng một",
      "tháng hai",
      "tháng ba",
      "tháng tư",
      "tháng năm",
      "tháng sáu",
      "tháng bảy",
      "tháng tám",
      "tháng chín",
      "tháng mười",
      "tháng mười một",
      "tháng mười hai",
    ],
    weekdays: ["chủ nhật", "thứ hai", "thứ ba", "thứ tư", "thứ năm", "thứ sáu", "thứ bảy"],
    meridiemParse: /am|pm/i,
    isPM(input) {
      return /^am$/i.test(input);
    },
    meridiem(hours, minutes, isLower) {
      if (hours < 12) {
        return isLower ? "am" : "AM";
      }
      return isLower ? "pm" : "PM";
    },
  });
}

export function updateVietnamLocale() {
  moment.updateLocale("vi", {
    months: "tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split(
      "_"
    ),
    monthsShort: "Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12".split("_"),
    monthsParseExact: true,
  });
}

class App extends Component {
  componentWillMount() {
    if (this.props.initURL === "") {
      this.props.setInitUrl(this.props.history.location.pathname);
    }
    updateMomentLocale();
  }

  render() {
    const { match, location, locale, authUser, initURL, isDirectionRTL, verify, user } = this.props;
    // if (location.pathname === "/") {
    //   if (authUser === null) {
    //     return <Redirect to={"/signin"} />;
    //   } else if (initURL === "" || initURL === "/" || initURL === "/signin") {
    //     return <Redirect to={"/admin/sample-page"} />;
    //   }
    //   return <Redirect to={initURL} />;
    // }

    // for RTL Support
    if (isDirectionRTL) {
      document.body.classList.add("rtl");
    } else {
      document.body.classList.remove("rtl");
    }

    const currentAppLocale = AppLocale[locale.locale];
    moment.locale(currentAppLocale.locale);

    return (
      <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
        <div className="app-main">
          <Switch>
            <RestrictedRoute path={`${match.url}admin`} authUser={user} component={MainApp} />
            <RestrictedRoute
              path={`${match.url}super-admin`}
              authUser={user}
              component={SuperAdmin}
            />
            <RestrictedRoute
              path={`${match.url}customer`}
              authUser={user}
              component={Customer}
            />
            <Route path="/login" component={LoginPage} />
            <Route path="/signup" component={SignupPage} />
            <Route path="/forgot-password" component={ForgotPasswordPage} />
            <Route path="/reset-password" component={ResetPasswordPage} />
            <Route path="/Error404" component={ErrorHandler} />
            <Route path="/SuperAdminMobileScreen" component={SuperAdminMobileScreen} />
            <Route path="/contact" component={ContactUs}/>
            <Route path='/access-denied' component={AccessDenied} />
            <Route path="/" component={CustomerFlow} />
            {/* <Route component={asyncComponent(() => import("components/Error404"))} /> */}
          </Switch>
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = ({ settings, auth, login }) => {
  const { locale, isDirectionRTL } = settings;
  const { authUser, initURL } = auth;
  const { verify, user } = login;
  return { locale, isDirectionRTL, authUser, initURL, verify, user };
};

export default connect(
  mapStateToProps,
  { setInitUrl }
)(App);



// WEBPACK FOOTER //
// ./containers/App.js